<template>
    <ul class="side-nav-menu scrollable">
        <template v-for="(item, index) in navItems">
            <template v-if="item.children">
                <side-nav-dropdown :key="index" :name="item.name" :url="item.url" :icon="item.icon">
                    <template v-for="(childL1, index1) in item.children">
                        <template v-if="childL1.children">
                            <!-- Second level dropdown -->
                            <side-nav-dropdown :key="index1" :name="childL1.name" :url="childL1.url" :icon="childL1.icon">
                                <li :key="index2" class="nav-item" v-for="(childL2, index2) in childL1.children">
                                    <side-nav-link :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                                </li>
                            </side-nav-dropdown>
                        </template>
                        <template v-else>
                            <side-nav-item :key="index1" :classes="item.class">
                                <side-nav-link :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                            </side-nav-item>
                        </template>
                    </template>
                </side-nav-dropdown>
            </template>
            <template v-else>
                <side-nav-item :key="index" :classes="item.class" v-bind:class="{ 'mrg-top-30': index==0 }">
                    <side-nav-link :name="item.name" :url="item.url" :icon="item.icon"/>
                </side-nav-item>
            </template>
        </template>
    </ul>
</template>

<script>
    import SideNavDropdown from "./SideNavDropdown";
    import SideNavItem from "./SideNavItem";
    import SideNavLink from "./SideNavLink";
    export default {
        name: "side-nav-menu",
        components: { SideNavLink, SideNavItem, SideNavDropdown},
        props: {
            navItems: {
                type: Array,
                required: true,
                default: () => []
            }
        }
    }
</script>

<style scoped>

</style>